module.exports = new __parcel__URL__("autosai_logo.99640ed2.svg").toString();